import React, { Component } from "react";
import { RegularExpressions } from "../../helpers/constants";
import { deviceMessages } from "../../helpers/messages";

export default class DeviceSearchComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchString: "",
			location: "",
			error: ""
		};
	}
	/**
	 *  @description Function to input change
	 *  @param value The value in the input field
	 *  @memberof DeviceSearchComponent
	 */
	handleOnChange = (key, value) => {
		if (!value) {
			this.setState({ [key]: '', error: '' });
			return;
		}
		if(key === 'searchString') {
		    this.setState({ [key]: value, error: !this.isValidString(value) ? deviceMessages.searchInputError:'' });
		} else {
			this.setState({ [key]: value, error: '' });
		}
	};

	/**
	 *  @description Function to validate the given string is alphanumeric characters
	 *  @paramstring The value in the input field
	 *  @memberof DeviceSearchComponent
	 */
	isValidString = (string) => {
		return RegularExpressions.alphanumericWithSpace.test(string)
	}

	/**
	 *  @description Function to handle search reset
	 *  @memberof DeviceSearchComponent
	 */
	handleReset = () => {
		this.setState({ searchString: "", location: "", error: "" });
		this.props.handleReset();
	};

	/**
	 *  @description Function to handle search submit by hitting enter key
	 *  @param e Keypress event
	 *  @memberof DeviceSearchComponent
	 */
	onEnterPress = (e) => {
		if (e.which === 13) {
			e.preventDefault();
			this.handleSubmit();
		}
	};

	/**
	 *  @description Function to handle search submit 
	 *  @memberof DeviceSearchComponent
	 */
	handleSubmit = () => {
		const { searchString, location } = this.state;
		/* istanbul ignore next  */
		if (searchString && !this.isValidString(searchString)) {
			this.setState({ error: deviceMessages.searchInputError });
		} else {
			this.props.handleSearchSubmit(searchString, location);
		}
	}

	render() {
		const { searchString, location, error } = this.state;

		return (
			<>
				<div className="form-group pt-3 d-flex  gap-2  m-0 " data-testid="deviceSearch">
					<select
						onChange={(e) => this.handleOnChange("location", e.target.value)}
						value={location}
						id="device-type"
						data-testid="device-type"
						className="form-select mr-4 device-search-dropdown"
					>
						<option key="all-devices" value="all">All Devices</option>
						<option key="Field" value="Field">Field Devices</option>
						<option key="R&D" value="R&D">R&D Devices</option>
					</select>
					<input
						type="text"
						data-testid="device-search"
						id="device-search"
						placeholder="Search for devices"
						className="device-search form-control "
						value={searchString}
						onChange={(e) => this.handleOnChange("searchString", e.target.value)}
						onKeyUp={this.onEnterPress}
					/>
					<button
						type="button"
						data-testid="search-submit"
						id="search-submit"
						className="btn btn-primary "
						disabled={searchString === "" && location === "" ? true : false}
						onClick={this.handleSubmit}
					>
						Search
					</button>
					<button type="button" data-testid="search-reset" id="search-reset" className="btn btn-secondary" onClick={this.handleReset}>Reset</button>
				</div>
				{error && <div className="text-danger">{error}</div>}
			</>
		);
	}
}
